import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { queryClient } from './services/queryClient';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Falta el contenedor #root en index.html');

createRoot(container).render(
  <StrictMode>
    {/* El cliente de consultas se crea en un módulo y no aquí: así los tests
        pueden importarlo y vaciar la caché entre casos. */}
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
